<script>
  import { applyDiscountAndFormatPrice } from '../../utils/pricing.js';
  import { environment } from '../../environment/environment.js';

  export let basePriceInCents = 3495;
  export let discounts;
  export let showFrontBackPrintPricing = true;
  export let title;
  export let selectedProductType;
  export let showInclusions;

  const printPricing = environment.PRINT_PRICING;
</script>

<div class="pricing-guide">
  <h3>Volume Pricing and Discount Levels</h3>
  <div class="gst-note">NOTE: All prices shown include GST</div>

  {#if title}
    <div class="label">{selectedProductType} - {title}</div>
  {/if}
  <table>
    <tr>
      <th>Qty</th>
      <th>Discount %</th>
      {#if showFrontBackPrintPricing}
        <th>Blank</th>
        <th>+ 1 Side Print</th>
        <th>+ 2 Side Print</th>
      {:else}
        <th>Item Price</th>
      {/if}
    </tr>
    <tbody>
      {#each discounts as discount (discount.id)}
        <tr>
          <td>
            {discount.minQty}
            {#if discount.maxQty !== null}
              - {discount.maxQty}
            {:else}
              +
            {/if}
          </td>
          <td>{discount.discountPercent}%</td>
          <td>${applyDiscountAndFormatPrice(basePriceInCents, discount.discountPercent)}</td>
          {#if showFrontBackPrintPricing}
            <td>${applyDiscountAndFormatPrice(basePriceInCents + printPricing.text, discount.discountPercent)}</td>
            <td
              >${applyDiscountAndFormatPrice(
                basePriceInCents + printPricing.text + printPricing.namenumber,
                discount.discountPercent,
              )}</td
            >
          {/if}
        </tr>
      {/each}
    </tbody>
  </table>

  {#if showInclusions}
    <div class="inclusions">
      <div class="info">All inclusive pricing includes:</div>
      <ul>
        <li>
          <b>FREE</b> Standard Shipping orders over $500
        </li>
        <li>
          <b>FREE</b> Logo Design
        </li>
        <li>
          <b>FREE</b> Design Mockups
        </li>
        <li>
          <b>FREE</b> Artwork Review
        </li>
        <li>
          <b>FREE</b> Artwork Setup
        </li>
        <li>Dedicated Customer Service Rep</li>
      </ul>
    </div>
  {/if}
</div>

<style>
  .pricing-guide {
    display: flex;
    flex-direction: column;
    margin-bottom: 4rem;
    margin-left: 4rem;
    margin-right: 4rem;
    align-items: center;
  }

  .gst-note {
    font-size: 1.4rem;
    font-weight: 600;
    color: #535353;
    margin-bottom: 5px;
  }

  table {
    margin: 0 auto;
  }

  table,
  th,
  td {
    text-align: center;
    border: 1px solid black;
  }

  th,
  td {
    padding: 1rem;
  }

  h3 {
    text-transform: uppercase;
    font-family: 'Oswald';
    color: #fe5900;
    padding-bottom: 2rem;
  }

  .inclusions {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 2.4rem;
  }

  .label {
    font-size: 2.4rem;
    text-align: center;
    display: block;
    text-transform: capitalize;
    padding: 1rem;
  }
</style>
